import React, { useState, useEffect } from "react";

const ModalManagement = ({
  type,
  section,
  showModal,
  setShowModal,
  selectedCategory,
  selectedSkill,
  handleAction,
}) => {
  const [newName, setNewName] = useState({ en: "", es: "" });

  // Inicializa los campos al abrir el modal
  useEffect(() => {
    if (!showModal[type]) return;

    if (type === "edit") {
      if (section === "category" && selectedCategory) {
        setNewName({
          en: selectedCategory.name_en || "",
          es: selectedCategory.name_es || "",
        });
      } else if (section === "skill" && selectedSkill) {
        setNewName({ en: selectedSkill.name || "", es: "" });
      }
    } else if (type === "create") {
      setNewName({ en: "", es: "" });
    }
  }, [showModal, type, section, selectedCategory, selectedSkill]);

  // Maneja continuar: envía ID + payload de forma consistente
  const handleContinue = () => {
    const payload =
      section === "category"
        ? { en: newName.en, es: newName.es }
        : { en: newName.en };

    let id = null;
    if (type === "edit") {
      if (section === "category") id = selectedCategory?.category_id;
      else if (section === "skill") id = selectedSkill?.skill_id;
    }

    handleAction(id, payload); // <-- ID primero, payload después
    setShowModal({ edit: false, delete: false, create: false });
  };

  if (!showModal[type]) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-2xl shadow-2xl w-[28%] p-6 border-t-4 border-[#ed4685]">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-[#2563EB]">
            {section === "category"
              ? type === "delete"
                ? "Delete category"
                : type === "edit"
                ? "Edit category"
                : "Create new category"
              : type === "delete"
              ? "Delete skill"
              : type === "edit"
              ? "Edit skill"
              : "Create new skill"}
          </h2>
          <button
            className="text-gray-400 hover:text-[#ed4685] text-2xl font-bold"
            onClick={() =>
              setShowModal({ edit: false, delete: false, create: false })
            }
          >
            &times;
          </button>
        </div>

        <div className="text-gray-700 text-sm">
          {type === "delete" ? (
            <p>
              Are you sure you want to delete{" "}
              <span className="font-semibold text-[#ed4685]">
                {section === "category"
                  ? `'${selectedCategory?.name_en || ""}'`
                  : `'${selectedSkill?.name || ""}'`}
              </span>
              ?
            </p>
          ) : (
            <div className="flex flex-col gap-3">
              <p>
                {type === "create"
                  ? `Enter new ${section} name:`
                  : `Change ${section} name:`}
              </p>
              {section === "category" ? (
                <>
                  <input
                    placeholder="Name (English)"
                    value={newName.en}
                    onChange={(e) =>
                      setNewName((prev) => ({ ...prev, en: e.target.value }))
                    }
                    className="border rounded px-4 py-2"
                  />
                  <input
                    placeholder="Name (Español)"
                    value={newName.es}
                    onChange={(e) =>
                      setNewName((prev) => ({ ...prev, es: e.target.value }))
                    }
                    className="border rounded px-4 py-2"
                  />
                </>
              ) : (
                <input
                  placeholder="Skill name"
                  value={newName.en}
                  onChange={(e) =>
                    setNewName((prev) => ({ ...prev, en: e.target.value }))
                  }
                  className="border rounded px-4 py-2"
                />
              )}
            </div>
          )}
        </div>

        <div className="flex justify-end gap-3 mt-6">
          <button
            className="px-4 py-2 rounded border hover:bg-gray-100"
            onClick={() =>
              setShowModal({ edit: false, delete: false, create: false })
            }
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 rounded bg-[#ed4685] text-white hover:bg-[#2563EB]"
            onClick={handleContinue}
            disabled={
              type !== "delete" &&
              ((section === "category" &&
                (!newName.en.trim() || !newName.es.trim())) ||
                (section === "skill" && !newName.en.trim()))
            }
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalManagement;
